import { Type } from 'class-transformer';
import { OrganizationModel } from '../../organizations/models/organization.model';
import { UserAccountSetting } from './account-settings.model';
import { ProfressionalSubscriptionModel } from './subscription/professional-subscription.model';
import { UserSubscriptionModel } from './subscription/user-subscription.model';

interface AccountVerificationModel {
    verification_jwt: string;
    verification_required: boolean;
}

export class UserProfileModel {
    city: string;
    first_name: string;
    last_name: string;
    institution: string;
    grade_level: string;
    country: string;
    sort_name_by_last: string;
    email: string;
    state: string;
    sort_email: string;
    eid: string;

    // user account settings
    account_settings: UserAccountSetting[];

    // account verification
    account_verification: AccountVerificationModel;
    
    @Type(() => OrganizationModel)
    organizations: OrganizationModel[];
    
    is_third_party: boolean;
    user_is_developer: boolean;
    id: number;
    third_party_provider_name: string;

    // subscription info
    subscription?: UserSubscriptionModel | ProfressionalSubscriptionModel;
    premium_account_type: string;
    premium_account: boolean;
    premium_account_valid: boolean;

    // developer info
    developer_account: boolean;
    developer_account_active: boolean;
    developer_account_verified: boolean;
}

export function isBiodigitalProfile(profile: UserProfileModel) {
    return profile.email.endsWith('@biodigital.com');
}
